import { render } from "./ProspectOpeningHours.vue?vue&type=template&id=3492de3f"
import script from "./ProspectOpeningHours.vue?vue&type=script&lang=js"
export * from "./ProspectOpeningHours.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__